import React from 'react'
import { Field } from 'redux-form'

import './PaymentMethodForm.scss'
import InputControl from 'components/InputControl'

import {
  createFieldValidator,
  required,
  isCreditCardNumber,
  isCvcNumber,
  hasNotExpired
} from 'utils/validations'

const PaymentMethodForm = () => {
  return (
    <div className='PaymentMethodForm'>
      <Field
        className='PaymentMethodForm-field PaymentMethodForm-numberField'
        component={InputControl}
        name='number'
        type='text'
        label='Número de tarjeta'
        validate={
          createFieldValidator([required, isCreditCardNumber])
        }
        />

      <Field
        className='PaymentMethodForm-field PaymentMethodForm-expMonthField'
        component={InputControl}
        name='exp_month'
        type='text'
        label='Mes'
        validate={
          createFieldValidator([required, hasNotExpired])
        }
        />

      <Field
        className='PaymentMethodForm-field PaymentMethodForm-expYearField'
        component={InputControl}
        name='exp_year'
        type='text'
        label='Año'
        validate={
          createFieldValidator([required, hasNotExpired])
        }
        />

      <Field
        className='PaymentMethodForm-field PaymentMethodForm-cvcField'
        component={InputControl}
        name='cvc'
        type='text'
        label='CVV'
        validate={
          createFieldValidator([required, isCvcNumber])
        }
        />

      <Field
        className='PaymentMethodForm-field PaymentMethodForm-nameField'
        component={InputControl}
        name='name'
        type='text'
        label='Nombre del titular'
        validate={
          createFieldValidator([required])
        }
        />
    </div>
  )
}

PaymentMethodForm.displayName = 'PaymentMethodForm'

export default PaymentMethodForm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/SecondTimeBookingConfirmation/components/PaymentMethodForm/PaymentMethodForm.js